var _excluded = ["isActive", "isDisabled", "variant", "syncIconStyle", "key", "href", "analyticsName", "aria-label"],
    _excluded2 = ["variant", "isActive", "isDisabled", "syncIconStyle"];

function cov_2ovd415noz() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Tab/Tab.tsx";
  var hash = "0961d0007614de70a7a065529887da73f71d3ede";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Tab/Tab.tsx",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 19
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "1": {
        start: {
          line: 32,
          column: 34
        },
        end: {
          line: 38,
          column: 6
        }
      },
      "2": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "3": {
        start: {
          line: 55,
          column: 28
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "4": {
        start: {
          line: 62,
          column: 17
        },
        end: {
          line: 62,
          column: 61
        }
      },
      "5": {
        start: {
          line: 64,
          column: 18
        },
        end: {
          line: 64,
          column: 20
        }
      },
      "6": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 67,
          column: 3
        }
      },
      "7": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 27
        }
      },
      "8": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 70,
          column: 3
        }
      },
      "9": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 29
        }
      },
      "10": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 73,
          column: 3
        }
      },
      "11": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 34
        }
      },
      "12": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 75,
          column: 31
        }
      },
      "13": {
        start: {
          line: 78,
          column: 0
        },
        end: {
          line: 80,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 31,
            column: 7
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 31
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 55,
            column: 28
          },
          end: {
            line: 55,
            column: 29
          }
        },
        loc: {
          start: {
            line: 61,
            column: 54
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 61
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 65
      },
      "1": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 68
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 71
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0961d0007614de70a7a065529887da73f71d3ede"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ovd415noz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2ovd415noz();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { forwardRef } from '@chakra-ui/system';
import { useStyleConfig } from '../../system/utils';
import { Link } from '..';
export var Tab = (cov_2ovd415noz().s[0]++, forwardRef(function (_ref, ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      variant = _ref.variant,
      syncIconStyle = _ref.syncIconStyle,
      _key = _ref.key,
      href = _ref.href,
      analyticsName = _ref.analyticsName,
      ariaLabel = _ref['aria-label'],
      props = _objectWithoutProperties(_ref, _excluded);

  cov_2ovd415noz().f[0]++;

  var _ref2 = (cov_2ovd415noz().s[1]++, useTabStyles(_objectSpread({
    variant: variant,
    isActive: isActive,
    isDisabled: isDisabled,
    syncIconStyle: syncIconStyle
  }, props))),
      className = _ref2.className,
      styles = _ref2.styles;

  cov_2ovd415noz().s[2]++;
  return /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref,
    className: className // __css has a lower priority than sx
    ,
    __css: styles,
    analyticsName: analyticsName,
    "aria-label": ariaLabel,
    "aria-current": isActive
  }, props));
}));
cov_2ovd415noz().s[3]++;
export var useTabStyles = function useTabStyles(_ref3) {
  var variant = _ref3.variant,
      isActive = _ref3.isActive,
      isDisabled = _ref3.isDisabled,
      syncIconStyle = _ref3.syncIconStyle,
      props = _objectWithoutProperties(_ref3, _excluded2);

  cov_2ovd415noz().f[1]++;
  var styles = (cov_2ovd415noz().s[4]++, useStyleConfig('Tab', _objectSpread({
    variant: variant
  }, props)));
  var className = (cov_2ovd415noz().s[5]++, '');
  cov_2ovd415noz().s[6]++;

  if (isActive) {
    cov_2ovd415noz().b[0][0]++;
    cov_2ovd415noz().s[7]++;
    className += ' active';
  } else {
    cov_2ovd415noz().b[0][1]++;
  }

  cov_2ovd415noz().s[8]++;

  if (isDisabled) {
    cov_2ovd415noz().b[1][0]++;
    cov_2ovd415noz().s[9]++;
    className += ' disabled';
  } else {
    cov_2ovd415noz().b[1][1]++;
  }

  cov_2ovd415noz().s[10]++;

  if (syncIconStyle) {
    cov_2ovd415noz().b[2][0]++;
    cov_2ovd415noz().s[11]++;
    className += ' syncIconStyle';
  } else {
    cov_2ovd415noz().b[2][1]++;
  }

  cov_2ovd415noz().s[12]++;
  return {
    styles: styles,
    className: className
  };
};
cov_2ovd415noz().s[13]++;
Tab.defaultProps = {
  variant: 'nav-item'
};
export default Tab;